var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"p_title",on:{"click":_vm.openApp}},[_vm._v(" 返回应用(iOS) ")])])}
var staticRenderFns = []

export { render, staticRenderFns }